<h4 class="typo-h4-semibold text-center text-text-primary">{{ 'auto_draft_inactivity_title' | translate }}</h4>

<p class="typo-h5-book mt-[8px] whitespace-pre-line text-center text-text-secondary">{{ 'auto_draft_inactivity_message' | translate }}</p>

<p class="typo-h3-semibold mt-[16px] text-center text-primary-blue" data-testid="auto-countdown-dialog-remaining">{{ remainingLabel() }}</p>

<div class="mt-[16px] flex justify-center gap-[12px]">
  <button type="button" class="btn-secondary justify-center" data-testid="auto-countdown-dialog-keep-active" (click)="onKeepActive()">
    {{ 'auto_draft_inactivity_keep_active' | translate }}
  </button>
  <button type="button" class="btn-primary justify-center" data-testid="auto-countdown-dialog-end" (click)="onEndAppointment()">
    {{ 'auto_draft_inactivity_end' | translate }}
  </button>
</div>
